import script from "./PlanoEventoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanoEventoModal.vue?vue&type=script&setup=true&lang=js"

import "./PlanoEventoModal.vue?vue&type=style&index=0&id=2c5a1450&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5a1450"]])

export default __exports__